var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-root--portal': _vm.isPortalSite },attrs:{"id":"app-root"}},[_c('router-view'),_c('portal-login-modal',{attrs:{"visible":_vm.$store.state.portalLoginVisible,"redirect":_vm.$store.state.portalLoginRedirect}}),_c('coze-service-bot'),_c('fast-gpt-bot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }